const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

/** 서버·브라우저 시간대와 상관없는 한국 날짜(YYYY-MM-DD) */
export const getKstToday = (now: number = Date.now()) =>
  new Date(now + KST_OFFSET_MS).toISOString().slice(0, 10);
